module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_7-1.5759f208.png";